import { combineReducers } from "redux";

import { notificationStore } from "./Notifications";
import { session } from "./session";
import { shiftStore } from "./shift";

export const rootReducer = combineReducers({
  session,
  shiftStore,
  notificationStore,
});
